import { ListItem, Box } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from '../../../store'
import { openCase } from '../../../store/reports/reportsSlice'
import { triageLevelStates } from '../../../store/reports/types'
import usersSelectors from '../../../store/users/usersSelectors'
import timeUtils from '../../timeUtils'
import { IReportsListItem } from './types'
import authSelectors from '../../../store/auth/authSelectors'
import { APP_MODE } from '../../../sharedTypes'

const getString = (array: any[]) => {
  if (!array || array.length === 0) {
    return '-'
  }

  const newString = array.map(item => item?.full_name).join(',')
  return newString || '-'
}

const ReportsListItem: React.FC<IReportsListItem> = ({ report }) => {
  const dispatch = useDispatch<AppDispatch>()
  const appMode = useSelector(authSelectors.userOrganizationType)
  const teamMembers = useSelector(usersSelectors.teamMembers)
  const navigate = useNavigate()
  const routeChange = () => {
    dispatch(openCase({ caseId: report?.id, caseStatus: report.report_status.status }))

    if (
      report?.triage_level &&
      report.triage_level !== triageLevelStates.TRANSFERED_FOR_ASSIGNMENT
    ) {
      if (
        report.triage_level === triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED &&
        teamMembers?.length === 0
      ) {
        navigate('/cases/initialReport')
        return
      }

      if (appMode !== APP_MODE.full) {
        navigate('/cases/initialReport')
        return
      }

      navigate('/cases/overview')
      return
    }

    navigate('/cases/initialReport')
  }

  const resolveTitle = () => {
    return report?.triage_level ? (
      <span className='t-overflow-ellipsis'>#{report.uuid}</span>
    ) : (
      <>
        <span className='t-report-new-chip t-color-white t-d-iflex t-font-size-small t-font-bold'>
          NEW
        </span>{' '}
        <span className='t-overflow-ellipsis'>#{report.uuid}</span>
      </>
    )
  }

  return (
    <Box className='t-cursor-pointer t-report-item-wrap' onClick={routeChange}>
      <ListItem disablePadding>
        <Box className='t-report-item t-vbox t-gap-18 t-pt-18 t-pb-18'>
          <Box className='t-gap-18 t-d-flex t-justify-content-between t-report-item-line'>
            <div className='t-font-bold t-font-size-header t-color-black t-overflow-ellipsis t-d-iflex t-align-items-center'>
              {resolveTitle()}
            </div>
            <div className='t-color-gray t-font-size-body t-text-align-right t-overflow-ellipsis'>
              {timeUtils.getFormatedDate(report?.created_at)}
            </div>
          </Box>
          <Box className='t-gap-18 t-report-body t-d-flex t-justify-content-between t-report-item-line'>
            <div className='t-font-size-body t-color-black t-d-iflex'>
              <span className='t-overflow-ellipsis'>Subjects : {getString(report.subjects)}</span>
              <span className='t-dot'>&#x25CF;</span>
              <span className='t-overflow-ellipsis'>Victims : {getString(report.victims)}</span>
            </div>
            <div className='t-font-size-body t-color-gray t-d-flex'>
              <span className='t-overflow-ellipsis'>Tier {report.tier_level}</span>
              {/* <span className='t-dot'>&#x25CF;</span> */}
              {/* <span className='t-overflow-ellipsis'>{`${report.workplace?.work_city}, ${report.workplace?.work_state}`}</span> */}
            </div>
          </Box>
        </Box>
      </ListItem>
    </Box>
  )
}

export default ReportsListItem
